module.exports = __webpack_public_path__ + "img/base_activites_bagage.e76acdba.svg";